/**
 * Carry a party-list membership from the share link onto the cart.
 *
 * A guest opens the list from a WhatsApp message, taps through to the suit and
 * buys it. Without this, that order arrives looking like anybody's, and the
 * organiser is back to asking the group who has paid — which is the whole
 * question the list was meant to answer.
 *
 * The tag is signed by the API and is opaque here. It is put on the cart as an
 * attribute, which Shopify carries onto the order, where our webhook reads it
 * and settles that person's row.
 *
 * Set once and left alone: cart attributes persist, so this runs on the way in
 * from the link and never again. It is also kept in sessionStorage, because a
 * customer who empties their cart and starts again has not stopped being on
 * the list.
 */
(function () {
  'use strict';

  var KEY = 'tc_party_member';
  var ATTRIBUTE = '_tc_member';

  var fromUrl = new URLSearchParams(location.search).get('tcm');
  var tag = fromUrl || sessionStorage.getItem(KEY);
  if (!tag) return;

  if (fromUrl) {
    try { sessionStorage.setItem(KEY, fromUrl); } catch (e) { /* private mode */ }
  }

  /* Already on the cart: nothing to do, and no request to make on every
     product page for the rest of the visit. */
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      if (!cart || (cart.attributes && cart.attributes[ATTRIBUTE] === tag)) return;
      var body = {};
      body[ATTRIBUTE] = tag;
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: body }),
      });
    })
    .catch(function () {
      /* An order that cannot be attributed is still an order. The organiser
         loses a tick, the customer loses nothing, and neither is worth an
         error on a product page. */
    });
})();
